/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { StronglyTypedRuleInputParams } from './StronglyTypedRuleInputParams';
import type { TimeZoneDto } from './TimeZoneDto';

export type RulePatchDto = {
    createIncidentOnFail?: boolean;
    criticality?: number;
    customEmailSubject?: string;
    customMetadataEntriesOperation?: RulePatchDto.customMetadataEntriesOperation;
    customMetadataEntryIds?: Array<string>;
    description?: string;
    isOverridingNotificationRules?: boolean;
    mailIds?: Array<string>;
    message?: string;
    msTeamsIds?: Array<string>;
    ruleParamsInputValues?: StronglyTypedRuleInputParams;
    schedule?: string;
    scheduleTimezone?: TimeZoneDto;
    slackChannelIds?: Array<string>;
    tagIds?: Array<string>;
    termIds?: Array<string>;
    webhookIds?: Array<string>;
};

export namespace RulePatchDto {

    export enum customMetadataEntriesOperation {
        ADD = 'ADD',
        REPLACE = 'REPLACE',
    }


}
